import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'step3',
    label: 'Step 3 Comparison',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
